import React from 'react';
import { Check } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function ProofBar() {
  const {
    t
  } = useLanguage();
  return <div id="proof-section" className="bg-luxury-charcoal border-y border-luxury-gold/20 py-12" data-id="element-118">
      <div className="max-w-6xl mx-auto px-6" data-id="element-119">
        <div className="grid md:grid-cols-3 gap-8 text-center divide-y md:divide-y-0 md:divide-x divide-luxury-gold/20" data-id="element-120">
          <div className="flex flex-col items-center justify-center p-4" data-id="element-121">
            <div className="flex items-center text-luxury-gold mb-2" data-id="element-122">
              <Check className="w-4 h-4 mr-2" data-id="element-123" />
              <span className="text-sm uppercase tracking-widest" data-id="element-124">
                {t.proofBar.growth.label}
              </span>
            </div>
            <p className="font-serif text-3xl md:text-4xl text-white" data-id="element-125">
              {t.proofBar.growth.value}
            </p>
            <p className="text-luxury-gray text-sm mt-1" data-id="element-126">
              {t.proofBar.growth.sub}
            </p>
          </div>

          <div className="flex flex-col items-center justify-center p-4" data-id="element-127">
            <div className="flex items-center text-luxury-gold mb-2" data-id="element-128">
              <Check className="w-4 h-4 mr-2" data-id="element-129" />
              <span className="text-sm uppercase tracking-widest" data-id="element-130">
                {t.proofBar.engagement.label}
              </span>
            </div>
            <p className="font-serif text-3xl md:text-4xl text-white" data-id="element-131">
              {t.proofBar.engagement.value}
            </p>
            <p className="text-luxury-gray text-sm mt-1" data-id="element-132">
              {t.proofBar.engagement.sub}
            </p>
          </div>

          <div className="flex flex-col items-center justify-center p-4" data-id="element-133">
            <div className="flex items-center text-luxury-gold mb-2" data-id="element-134">
              <Check className="w-4 h-4 mr-2" data-id="element-135" />
              <span className="text-sm uppercase tracking-widest" data-id="element-136">
                {t.proofBar.revenue.label}
              </span>
            </div>
            <p className="font-serif text-3xl md:text-4xl text-white" data-id="element-137">
              {t.proofBar.revenue.value}
            </p>
            <p className="text-luxury-gray text-sm mt-1" data-id="element-138">
              {t.proofBar.revenue.sub}
            </p>
          </div>
        </div>
      </div>
    </div>;
}